import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withAppContext } from '../contexts/app';
import { withClinicalData } from '../contexts/clinicalData';

import ImageUploader from '../components/ImageUploader';

import QuestionMark from 'images/ask/icons/question-mark.png';

class Error extends Component {
  render() {
    return (
      <div className="error-view">
        <div className="container">
          <div className="error-view__left">
            <img className="error-view__image" src={QuestionMark} />
          </div>

          <div className="error-view__right">
            <h2 className="error-view__title">Oops! <br />Something went wrong.</h2>

            <span className="error-view__message">
              <p>We&apos;ve encountered an error processing your request. Please try again.</p>
            </span>

            <span className="error-view__buttons">
              <ImageUploader
                label="Try another photo"
                onUpload={this.onImageUpload.bind(this)}
              />
            </span>
          </div>
        </div>
      </div>
    );
  }

  onImageUpload(image) {
    this.props.app.onImageUpload(image);
  }

  errorString() {
    let error = this.props.app.error;

    if (error.graphQLErrors && error.graphQLErrors.length > 0) {
      return error.graphQLErrors[0].message;
    }
    else {
      return 'Something went wrong. Please try another image.';
    }
  }
}

Error.defaultProps = {};

Error.propTypes = {
  app: PropTypes.object.isRequired,
  clinicalData: PropTypes.object.isRequired
};

export { Error };
export default withAppContext(withClinicalData(Error));
